// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"async-node_modules_diff_lib_index_mjs":"c355743ff57ca2b7e120","common":"bf7a9ccb1bea1433708c","js_pages_job_submit_js":"72f6f09613ce9d403358"}[chunkId] + ".js";
};